var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3105 6.40332L16.623 11.7158C16.9902 12.083 16.9902 12.6768 16.623 13.04L15.7402 13.9229C15.373 14.29 14.7793 14.29 14.416 13.9229L10.6465 10.1611L6.88086 13.9268C6.51367 14.2939 5.91992 14.2939 5.55664 13.9268L4.66992 13.0439C4.30273 12.6768 4.30273 12.083 4.66992 11.7197L9.98242 6.40723C10.3496 6.03613 10.9434 6.03613 11.3105 6.40332Z",
    fill: "#D4D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUpIcon);
export default __webpack_public_path__ + "static/media/angle-up-icon.da8ca9dae7d893d64a29b95d50f38d85.svg";
export { ForwardRef as ReactComponent };